module.exports = __webpack_public_path__ + "static/tissue-patch-764c9a8c99f56807b1224565d39621d5.jpg";